import axios from 'axios'
import lodash from 'lodash'

const productDecorator = product => {
  const colors = [],
    sizes = [],
    specs = lodash.filter(product.specs, spec => {
      let price = spec.price * spec.store_discount / 100

      if (spec.rate) {
        price += price * spec.rate / 100
      }
      spec.sale_price = price.toFixed(2)
     
      //spec.discount = (spec.chanel_discount < 100 ? spec.chanel_discount : 0) / 10
      spec.discount = ((spec.sale_price / spec.price)*10).toFixed(2)
      if (spec.stock > 0) {
        spec.color && colors.push(spec.color)
        spec.size && sizes.push(spec.size)
        return true
      }
      return false
    })
  const minSpec = lodash.minBy(specs, spec => spec.price)

  if (product.specs.length == 0) {
    console.log('product.specs.length == 0', product.id)
  }
  if(minSpec && !minSpec.photos) {
    minSpec.photos = []
  }
  if (minSpec) {
    product.main_photo = product.main_photo || minSpec.photos[0]
    product.price = minSpec.price
    product.sale_price = minSpec.sale_price
    product.discount = minSpec.discount
  }

  product.specs = specs
  product.colors = lodash.uniq(colors)
  product.sizes = lodash.uniq(sizes)

  if (product.org_id == 0) {
    product.typeText = "自营"
  } else {
    if (product.org_type == 1) {
      product.typeText = "三方"
      product.thirdparty = true

    } else if (product.org_type == 2) {
      product.typeText = "海淘"
      product.international = true
    }
  }

  //console.log(g)

  // product.photos = [product.main_photo].concat(lodash.flatten(product.specs.map(spec => {
  //   if (spec.stock > 0) {
  //     return spec.photos
  //   }
  //   return []
  // })))
  return product
}

export default {
  namespaced: true,
  state: {
    searching: true,
    goods: []
  },
  mutations: {
    setSearching(state, searching) {
      state.searching = searching
    },
    setGoods(state, { goods = [], merge = false } = {}) {
      state.searching = false
      state.goods = merge ? lodash.uniqBy([...state.goods, ...goods], goods => goods.id) : goods
    },
    resetGoods(state) {
      state.goods = []
      state.searching = true
    }
  },
  actions: {
    async searchGoods({ commit }, { keywords = '', page = 1, sort = 'new', brand = null } = {}) {
      commit('setSearching', true)

      var params = {
        'scopeOfStock': true,
        'page': page,
        'per_page': 20,
        'keywords': keywords,
        'listType': sort,
        'brand': brand
      }
      
      const resposne = await axios.get('/products', {
        params
      })
      commit('setGoods', {
        goods: resposne.data.data.list.map(p => productDecorator(p)),
        merge: page > 1
      })
    },
    async resetGoods({ commit }) {
      return commit('resetGoods')
    }
  }
}
